import './Partnerships.css';

const partnershipsData = [
  {
    id: 1,
    name: 'Almeone',
    icon: 'fas fa-handshake',
    description: 'Strategic sister company headquartered in Qatar, enabling a joint delivery framework for enterprise and government clients across the Middle East and globally. Specializing in integrated solutions spanning advanced data engineering, applied AI, and end-to-end enterprise digital transformation—adhering to international compliance and security standards.',
  },
  {
    id: 2,
    name: 'Microsoft Partner',
    icon: 'fab fa-microsoft',
    description: 'Enrolled Microsoft Partner with access to partner.microsoft.com. Expertise across Microsoft Cloud, Azure, Microsoft 365, and enterprise integrations.',
  },
  {
    id: 3,
    name: 'Dynatrace Partner',
    icon: 'fas fa-chart-line',
    description: 'Partnering with Dynatrace for full-stack observability and performance monitoring. AI-powered monitoring, root cause analysis, and enterprise observability solutions.',
  },
];

const Partnerships = () => {
  return (
    <div className="container">
      <h2 className="section-title">Our Strategic Partnerships</h2>
      <p className="partnerships-intro">
        Sradhatech collaborates with leading technology partners to deliver secure, scalable, and enterprise-grade solutions across cloud, identity, observability, and digital transformation.
      </p>
      <div className="partnerships-grid">
        {partnershipsData.map((partnership, index) => (
          <div
            key={partnership.id}
            className="partnership-card"
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <div className="home-partnership-icon">
              <i className={partnership.icon}></i>
            </div>
            <h3>{partnership.name}</h3>
            <p>{partnership.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Partnerships;

